import { CSSProperties, cloneElement, isValidElement, useState } from 'react';
import { createPortal } from 'react-dom';

import LimitReachedTooltip from '~/components/isolated/LimitReachedTooltip';

import { ValidationTooltipProps } from './interfaces';
import styles from './ValidationTooltip.module.scss';

const ValidationTooltip = ({
  children,
  title,
  open,
  onClose,
}: ValidationTooltipProps) => {
  const [elementRef, setElementRef] =
    useState<Nullable<HTMLButtonElement>>(null);

  const getTooltip = () => {
    const rect = elementRef?.getBoundingClientRect();

    if (!rect) {
      return null;
    }

    const tooltipStyle: CSSProperties = {
      position: 'fixed',
      top: `${rect.top - 12}px`,
      left: `${rect.left + rect.width / 2}px`,
      transform: 'translate(-50%, -100%)',
    };

    return (
      <LimitReachedTooltip
        isLimitReached={open}
        anchor={elementRef}
        className={styles.tooltip}
        onClose={onClose}
        style={tooltipStyle}
      >
        {title}
      </LimitReachedTooltip>
    );
  };

  const renderTooltip = () => {
    if (typeof document === 'undefined' || !open) {
      return null;
    }

    return createPortal(getTooltip(), document.body);
  };

  if (
    !isValidElement<{ ref: (node: Nullable<HTMLButtonElement>) => void }>(
      children,
    )
  ) {
    return children;
  }
  return (
    <>
      {cloneElement(children, {
        ref: (node: Nullable<HTMLButtonElement>) => {
          setElementRef(node);
        },
      })}
      {renderTooltip()}
    </>
  );
};

export default ValidationTooltip;
